import { createReducer } from "sc/helpers/reducer";
import {
  ENGINEER_SEARCH_NEEDLE_CHANGED,
  ENGINEER_SEARCH_RESULTS_LOADED,
} from "../actions/engineers";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [ENGINEER_SEARCH_NEEDLE_CHANGED]: (state, action) => null,
  [ENGINEER_SEARCH_RESULTS_LOADED]: (state, action) => action.payload.engineers,
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/engineer-search-results-reducer.js